import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { CircleCheck as CheckCircle2, MapPin, MessageCircle, Phone, Sparkles } from 'lucide-react';
import { PHONE_LOCAL, PHONE_TEL_HREF, WHATSAPP_HREF } from "@/lib/contact";
export default function AqeeqOvenServiceHero() {
  const phone = PHONE_LOCAL;
  const whatsappUrl = WHATSAPP_HREF;
  return <section id="aqeeqovenservicehero" data-nav="light" dir="rtl" className="relative overflow-hidden bg-background py-16 md:py-24 text-foreground border-b border-border">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-12">
          {/* Main content block */}
          <div className="flex flex-col items-start gap-6 lg:col-span-7">
            <div className="flex flex-wrap items-center gap-2">
              <Badge variant="secondary" className="flex items-center gap-1.5 px-3 py-1 text-xs sm:text-sm">
                <MapPin className="size-3.5 text-primary" />
                <span>خدمة فورية في حي العقيق، الرياض</span>
              </Badge>
              <Badge variant="outline" className="flex items-center gap-1.5 px-3 py-1 text-xs sm:text-sm text-muted-foreground">
                <Sparkles className="size-3.5 text-primary" />
                <span>لمسة احتراف</span>
              </Badge>
            </div>

            <h1 className="text-3xl font-bold tracking-tight text-foreground sm:text-4xl md:text-5xl lg:leading-[1.25]">
              تنظيف أفران حي العقيق بالرياض وصيانتها المنزلية الشاملة
            </h1>

            <p className="text-base leading-relaxed text-muted-foreground sm:text-lg">
              نوفر لسكان حي العقيق بالرياض خدمة منزلية متكاملة لغسيل وصيانة أفران الغاز والكهرباء، مع إزالة الدهون المستعصية، وتنظيف الشعلات والعيون، وتبديل قطع الغيار التالفة بأيدي فنيين متخصصين دون الحاجة لنقل الفرن من منزلك.
            </p>

            {/* Feature highlights */}
            <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 w-full pt-1">
              <div className="flex items-center gap-2.5 rounded-lg border border-border bg-card p-3 shadow-xs">
                <CheckCircle2 className="size-5 shrink-0 text-primary" />
                <span className="text-sm font-medium">خدمة فورية داخل منازل حي العقيق</span>
              </div>
              <div className="flex items-center gap-2.5 rounded-lg border border-border bg-card p-3 shadow-xs">
                <CheckCircle2 className="size-5 shrink-0 text-primary" />
                <span className="text-sm font-medium">إزالة الدهون المستعصية وتلميع الأفران</span>
              </div>
              <div className="flex items-center gap-2.5 rounded-lg border border-border bg-card p-3 shadow-xs">
                <CheckCircle2 className="size-5 shrink-0 text-primary" />
                <span className="text-sm font-medium">صيانة أعطال الشعلات والمفاتيح وتغيير القطع</span>
              </div>
              <div className="flex items-center gap-2.5 rounded-lg border border-border bg-card p-3 shadow-xs">
                <CheckCircle2 className="size-5 shrink-0 text-primary" />
                <span className="text-sm font-medium">فحص أمان كامل لأنظمة الغاز والكهرباء</span>
              </div>
            </div>

            {/* Action Buttons */}
            <div className="flex flex-wrap items-center gap-4 pt-2">
              <Button asChild size="lg" className="gap-2 text-base font-medium">
                <a href={PHONE_TEL_HREF}>
                  <Phone className="size-4" />
                  <span>اتصل الآن: {phone}</span>
                </a>
              </Button>

              <Button asChild variant="secondary" size="lg" className="gap-2 text-base font-medium">
                <Link to={whatsappUrl} newTab>
                  <MessageCircle className="size-4 text-emerald-500" />
                  <span>مراسلة واتساب</span>
                </Link>
              </Button>
            </div>
          </div>

          {/* Service visual representation */}
          <div className="relative lg:col-span-5">
            <div className="relative mx-auto aspect-4/3 w-full max-w-lg overflow-hidden rounded-2xl border border-border bg-muted shadow-lg">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1828342/img/aqeeq_oven_cleaning_service.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1828342/img/aqeeq_oven_cleaning_service.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1828342/img/aqeeq_oven_cleaning_service.webp-wvc-sizes" alt="فني صيانة وتنظيف أفران منزلي في حي العقيق الرياض" loading="lazy" decoding="async" className="h-full w-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-background/80 via-transparent to-transparent pointer-events-none" />
              <div className="absolute bottom-4 right-4 left-4 rounded-lg bg-card/95 p-3.5 backdrop-blur-xs border border-border shadow-xs">
                <div className="flex items-center justify-between text-xs text-muted-foreground">
                  <span className="font-semibold text-foreground">خدمة منزلية معتمدة</span>
                  <span className="text-primary font-medium">حي العقيق - الرياض</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}